module.exports = __webpack_public_path__ + "img/grt.a08f8cfe.svg";